export const HAPTICS_STORAGE_KEY = 'slashRoll.corebound.haptics.v1';
export const COMBAT_VIBRATIONS = { dealt: 150, received: 220 };
let sessionPreference;

export const supportsCombatHaptics = () =>
  typeof window !== 'undefined' &&
  typeof navigator !== 'undefined' &&
  /Android/i.test(navigator.userAgentData?.platform || navigator.userAgent) &&
  typeof navigator.vibrate === 'function';

export const getCombatHapticsEnabled = () => {
  if (sessionPreference !== undefined) return sessionPreference;
  try {
    return localStorage.getItem(HAPTICS_STORAGE_KEY) !== 'off';
  } catch {
    return true;
  }
};

export const stopCombatHaptics = () => {
  if (
    typeof navigator !== 'undefined' &&
    typeof navigator.vibrate === 'function'
  ) {
    try {
      navigator.vibrate(0);
    } catch {
      /* Unsupported or blocked by the browser. */
    }
  }
};

export const setCombatHapticsEnabled = (enabled) => {
  sessionPreference = enabled;
  try {
    localStorage.setItem(HAPTICS_STORAGE_KEY, enabled ? 'on' : 'off');
  } catch {
    /* Keep the preference for this session when storage is unavailable. */
  }
  if (!enabled) stopCombatHaptics();
};

export const combatHaptic = (kind) => {
  const duration = COMBAT_VIBRATIONS[kind];
  if (
    !duration ||
    !supportsCombatHaptics() ||
    !getCombatHapticsEnabled() ||
    document.hidden ||
    navigator.userActivation?.hasBeenActive === false
  )
    return false;
  try {
    return navigator.vibrate(duration);
  } catch {
    return false;
  }
};
